import { Button, ButtonMode, Icon, ICONS, Tooltip } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './NoContent.module.scss';

const cx = classNames.bind(styles);

interface NoContentButtonParams {
  ariaLabel?: string;
  title: string;
  onClick: () => void;
  disabled?: boolean;
  iconName?: ICONS;
  tooltip?: {
    content: string;
    disabled?: boolean;
    dataTestId?: string;
  };
}

export interface NoContentProps {
  dataTestId: string;
  header: string;
  infoMessage?: string;
  iconName?: ICONS;
  buttonParams?: NoContentButtonParams;
}

const NoContent = ({ dataTestId, header, infoMessage, iconName, buttonParams }: NoContentProps): React.ReactElement => {
  const renderButton = ({ ariaLabel, disabled, title, onClick, iconName, tooltip }: NoContentButtonParams) => {
    const button = (
      <div className={cx('action-button-wrapper')}>
        <Button
          ariaLabel={ariaLabel}
          className={cx('action-button')}
          dataTestId="no-content-action-button"
          disabled={disabled}
          mode={ButtonMode.PRIMARY}
          onClick={onClick}
        >
          {iconName && <Icon height={12} width={12} name={iconName} dataTestId="no-content-btn-icon" />}
          {title}
        </Button>
      </div>
    );

    if (tooltip) {
      return (
        <Tooltip disabled={tooltip.disabled} content={tooltip.content}>
          {button}
        </Tooltip>
      );
    }

    return button;
  };

  return (
    <div className={cx('body')} data-testid={dataTestId}>
      {iconName && <Icon height={196} width={196} name={iconName} dataTestId="no-content-icon" />}
      <h2 className={cx('header')}>{header}</h2>
      {infoMessage && (
        <p className={cx('info-message')} data-testid="no-content-info-message">
          {infoMessage}
        </p>
      )}
      {buttonParams && renderButton(buttonParams)}
    </div>
  );
};

export default NoContent;
